import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

window.addEventListener("load", function () {
  let fb = this.document.querySelector("#js-fixed-button");
  let cp = this.document.querySelector(".upsd-container_p");
  let section = this.document.querySelector(".upsd-nominations");

  if (fb && section && cp) {
    let rect = cp.getBoundingClientRect();

    // position the button
    fb.style.right = (window.innerWidth - rect.width) / 2 + "px";
    fb.style.right = rect.x + "px";

    fb.addEventListener("click", function (event) {
      event.preventDefault();
      gsap.to(window, { duration: 1, scrollTo: section });
    });
  }
});
